import React, { useContext, useState, useEffect } from "react";
import { Box, Typography, Button, Dialog,DialogContent,DialogActions, DialogContentText, DialogTitle,} from "@mui/material";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomSelectedOptions from "../CommonComponents/CustomSelectedOptions";
import {getdevicelist,setEAnalyticsData,getEAnalyticsData, getTagConfiguration} from "../../Restclient/datacollection"; ///
import { useSelector } from "react-redux";
import LK_Add from "../../images/LK_Add";
import LK_Delete from "../../images/LK_Delete";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import CustomToast from "../CommonComponents/CustomToast";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomTimePicker from "../CommonComponents/CustomTimePicker";
import CustomNumberField from "../CommonComponents/CustomNumberField";
import dayjs from "dayjs";
import LK_ArrowDown from '../../images/LK_ArrowDown';
import CustomLabel from "../CommonComponents/CustomLabel";
import LK_ArrowRight from '../../images/LK_ArrowRight';

import {Tree} from "antd";
import { set } from "date-fns";

export default function EnergyAnalyticsConfiguration() {
  const { theme } = useContext(ThemeContext);
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [MDThershold, setMDThershold] = React.useState(0.0);
  const [MDTag, setMDTag] = React.useState({Device:"", Tag:"", Aggregation:""});
  const [selectedDevicesList, setSelectedDevicesList] = React.useState([]);
  const [aggregationOption, setAggregationOption] = useState([]);
    const [disabledAggOptions, setDisabledAggOptions] = useState([]);
  const [guzzlersSelectedTags, setGuzzlersSelectedTags] = React.useState([]);
    const [selectedTagDetails, setSelectedTagDetails] = useState(null);
    const [selectedRightItems, setSelectedRightItems] = useState([]);
    const [rightList, setRightList] = useState([]);
      const [selectedTagList, setSelectedTagList] = useState([]);
      const [table_rows, setTable_rows] = useState([]);
    
  
  const [powerSupply, setpowerSupply] = React.useState({
    EB: "",
    DG: "",
    RE: "",
  });
  const [powerTagSupply, setpowerTagSupply] = React.useState({
    EBTag: "",
    DGTag: "",
    RETag: "",
  });
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const [devicelist, setDevicelist] = useState([[],[]]);
  const [deviceTaglist, setDeviceTaglist] = useState([]);
  const [shiftDetails, setShiftDetails] = React.useState([
    ["", [dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]],
  ]);
  const [TOD, setTOD] = React.useState([
    ["", [[dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]], ""],
  ]);
  const [maxlimitmsg, setMaxlimitmsg] = useState([0, ""]);
  const [loading, setLoading] = useState(1);
  const [loadingcnt, setLoadingcnt] = useState(0);
  const [OGData, setOGData] = useState([]);
  const [disableButtons, setDisableButtons] = useState(99);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [openTagDialog, setOpenTagDialog] = useState([false, ""]);
  const [tagConfiguration, setTagConfiguration] = React.useState([]);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [currentSelectedTag, setCurrentSelectedTag] = useState({Device:'', Tag:'', Aggregation:''});
  const [showWidget, setShowWidget] = useState({Guzzlers:false, Shiftwise:false, TOD:false});
  // const [disabledFrequency, setDisabledFrequency] = useState([]);
  // const [currStorage, setCurrStorage] = useState(null);
  
  //for disableButtons = 0, all buttons are enabled
  //for disableButtons = 99, all buttons are disabled

  useEffect(() => {
    setLoading(1);
    getdevicelist(getdevicelistcallback);
    getEAnalyticsData(getEAnalyticsDatacallback);
    getTagConfiguration(getTagCallback);
  }, []);

  useEffect(() => {
    setLoading(1);
    getdevicelist(getdevicelistcallback);
    getEAnalyticsData(getEAnalyticsDatacallback);
    getTagConfiguration(getTagCallback); 
  }, [projectname]);

  useEffect(() => {
    if (loadingcnt == 2) {
      setLoading(0);
      setDisableButtons(0);
      setLoadingcnt(0);
    }
  }, [loadingcnt]);

    function handleAggregationOption(selectedValue, isChecked) {
    if (isChecked) {
      // Add the value if checked (isChecked = true means checkbox is now checked)
      setAggregationOption([...aggregationOption, selectedValue]);
      setCurrentSelectedTag({...currentSelectedTag, Aggregation:selectedValue}); 
    } else {
      // Remove the value if unchecked (isChecked = false means checkbox is now unchecked)
      setAggregationOption(
        aggregationOption.filter((item) => item !== selectedValue),
      );
      setCurrentSelectedTag({...currentSelectedTag, Aggregation:''});
    }
  }

  // useEffect(() => {

  //   if (OGData.length !== 0) {
  //     const powerSupplyData = {
  //       EB: handleDeviceIDtoName([OGData[0].EB]),
  //       DG: handleDeviceIDtoName([OGData[0].DG]),
  //       RE: handleDeviceIDtoName([OGData[0].RE]),
  //     };
  //     setpowerSupply({
  //       EB: powerSupplyData.EB.length !== 0 ? powerSupplyData.EB[0] : "",
  //       DG: powerSupplyData.DG.length !== 0 ? powerSupplyData.DG[0] : "",
  //       RE: powerSupplyData.RE.length !== 0 ? powerSupplyData.RE[0] : "",
  //     });
  //     setSelectedDevicesList(handleDeviceIDtoName(OGData[0].GuzzlerDeviceID));
  //   }
  //   // if(loadingcnt==2){
  //   //     setLoading(0);
  //   //     setDisableButtons(0);
  //   //     setLoadingcnt(0);
  //   // }
  // }, [devicelist]);

  const getTagCallback = (res) => {
    setTagConfiguration(res);
  };


  function getdevicelistcallback(res) {
    let data = [[], []];
    res.map((_val, index) => {
      data = [
        [...data[0], res[index].DeviceID],
        [...data[1], res[index].Name],
      ];
    });
    setDevicelist(data);
    setLoading(0);
    // setLoadingcnt(loadingcnt+1);
  }

  function getEAnalyticsDatacallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      if (res.data.data.length !== 0) {
        /// if data is present in db
        // const powerSupplyData = {'EB':handleDeviceIDtoName([res.data.data[0].EB]), 'DG':handleDeviceIDtoName([res.data.data[0].DG]), 'RE':handleDeviceIDtoName([res.data.data[0].RE])}
        setpowerSupply({'EB':res.data.data[0].EB, 'DG':res.data.data[0].DG, 'RE':res.data.data[0].RE});
        setpowerTagSupply({'EBTag':res.data.data[0].EBEnergyTag, 'DGTag':res.data.data[0].DGEnergyTag, 'RETag':res.data.data[0].REEnergyTag});
        // setSelectedDevicesList(handleDeviceIDtoName(res.data.data[0].GuzzlerDeviceID));
        setSelectedDevicesList(res.data.data[0].GuzzlerDeviceID);
        setGuzzlersSelectedTags(res.data.data[0].GuzzlersEnergyTag);
        setMDThershold(res.data.data[0].MDThreshold);
        setMDTag(res.data.data[0].MDTag);
        setShiftDetails(cloneShiftDetails(res.data.data[0].ShiftDetails));
        setTOD(cloneTOD(res.data.data[0].TOD));
        setShowWidget(res.data.data[0].ShowWidget);
        // setOGData(structuredClone(res.data.data));
        setOGData([
          {
            EB: res.data.data[0].EB,
            DG: res.data.data[0].DG,
            RE: res.data.data[0].RE,
            GuzzlerDeviceID: res.data.data[0].GuzzlerDeviceID,
            MDThreshold: res.data.data[0].MDThreshold,
            ShiftDetails: cloneShiftDetails(res.data.data[0].ShiftDetails),
            TOD: cloneTOD(res.data.data[0].TOD),
            MDTag: res.data.data[0].MDTag,
            ShowWidget: res.data.data[0].ShowWidget,
            GuzzlersEnergyTag: res.data.data[0].GuzzlersEnergyTag,
          },
        ]);
        // setLoading(0);
        // setDisableButtons(0);
      } else {
        /// not initailsed / defualt setting
        setOGData([
          {
            EB: powerSupply.EB,
            DG: powerSupply.DG,
            RE: powerSupply.RE,
            GuzzlerDeviceID: selectedDevicesList,
            MDThreshold: MDThershold,
            ShiftDetails: cloneShiftDetails(shiftDetails),
            TOD: cloneTOD(TOD),
            MDTag: MDTag,
            ShowWidget: showWidget,
            GuzzlersEnergyTag: guzzlersSelectedTags,
          },
        ]);
      }
    } else {
      ///what needs to be done if error
    }
    setLoading(0);
    // setLoadingcnt(loadingcnt+1);
    setDisableButtons(0);
  }

  // const handleClose = (event, reason) => {
    
  // };

  const handleCloseAddForm = () => {
    setOpenCancelDialog(true);
    // setRequired(0);
    // setSaveStatus(0);
    // setAssetInfo({organizationId:"",projectId:"",id:"",data:{assetName:"",serialNo:"",description:"",/*commissionDate:"",decommissionDate:"",*/associatedDevices:[]}})
  };

  function handleDeviceNametoID(deviceName) {
    let id = [];
    for (let j = 0; j < deviceName.length; j++) {
      for (let i = 0; i < devicelist[1].length; i++) {
        if (devicelist[1][i] === deviceName[j]) {
          id = [...id, devicelist[0][i]];
        }
      }
    }
    return id;
  }

  function handleDeviceIDtoName(deviceName) {
    let id = [];
    for (let j = 0; j < deviceName.length; j++) {
      for (let i = 0; i < devicelist[0].length; i++) {
        if (devicelist[0][i] === deviceName[j]) {
          id = [...id, devicelist[1][i]];
        }
      }
    }
    return id;
  }

  const handleSaveAddForm = () => {
    let req = 0;
    TOD.map((val) => {
      if (val[0] === "" || val[2] === "") {
        req = 1;
      } else {
        val[1].map((value) => {
          if (value === "") {
            req = 1;
          }
        });
      }
    });
    shiftDetails.map((val) => {
      if (val[0] === "" || val[1] === "") {
        req = 1;
      }
    });
    if (
      // powerSupply.EB !== "" /*&& powerSupply.DG!=="" && powerSupply.RE!==""*/ &&
      req !== 1 && (MDTag.Tag !== "" && MDTag.Aggregation !== "" && MDTag.Device !== "")
    ) {
      const eb = handleDeviceNametoID([powerSupply.EB]);
      const dg = handleDeviceNametoID([powerSupply.DG]);
      const re = handleDeviceNametoID([powerSupply.RE]);
      const info = {
        // OrgId:userdetails.Organizationid,
        // ProjectId:projectname,
        EB: eb.length > 0 ? eb[0] : "",
        DG: dg.length > 0 ? dg[0] : "",
        RE: re.length > 0 ? re[0] : "",
        GuzzlerDeviceID:selectedDevicesList,
        GuzzlersEnergyTag:guzzlersSelectedTags,
        MDThershold: MDThershold,
        MDTag: MDTag,
        TOD: TOD,
        shiftDetails: shiftDetails,
        ShowWidget: showWidget,
      };
      setEAnalyticsData(info, callback);
      setRequired(0);
      setLoading(1);
    } else {
      setRequired(1);
    }
  };

  function callback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setLoading(0);
      setSaveStatus(1);
      setOGData([
        {
          EB: powerSupply.EB,
          DG: powerSupply.DG,
          RE: powerSupply.RE,
          GuzzlerDeviceID: selectedDevicesList,
          GuzzlersEnergyTag:guzzlersSelectedTags,
          MDThreshold: MDThershold,
          ShiftDetails: cloneShiftDetails(shiftDetails),
          TOD: cloneTOD(TOD),
          MDTag: MDTag,
          ShowWidget: showWidget,
        },
      ]);
    } else {
      setLoading(0);
      setSaveStatus(2);
      //
    }
  }

  function handleMDThershold(selectedValue) {
    setMDThershold(selectedValue);
  }

  function handleSelectedOption(selected) {
    setSelectedDevicesList([...selected]);
  }

  function handleRemoveOption(selectedValue,id) {
    if(id==="EB"){
      setpowerSupply({...powerSupply, EB: ""});
      setpowerTagSupply({...powerTagSupply, EBTag: ""});
    } else if(id==="DG"){
      setpowerSupply({...powerSupply, DG: ""});
      setpowerTagSupply({...powerTagSupply, DGTag: ""});
    } else if(id==="RE"){
      setpowerSupply({...powerSupply, RE: ""});
      setpowerTagSupply({...powerTagSupply, RETag: ""});
    }else if(id==="MDTag"){
      setMDTag({Device: "", Tag: ""});
    }else if(id==="Guzzlers"){
      const temp = guzzlersSelectedTags.filter((val,index) => index !== parseInt(selectedValue, 10));
      setGuzzlersSelectedTags(temp);
      // setSelectedDevicesList([]);
    }

    // const temp = selectedDevicesList.filter(
    //   (_value, index) => index !== parseInt(selectedValue, 10),
    // );
    // setSelectedDevicesList(temp);
  }

    const moveLeft = () => {
    if (selectedRightItems.length > 0) {
      // Remove selected items from rightList
      const updatedRightList = selectedTag.filter(
        (item) => !selectedRightItems.includes(item),
      );
      // setRightList(updatedRightList);

      

      setSelectedTag(updatedRightList);

      // Clear selected items
      setSelectedRightItems([]);
    } else {
    }
  };

  const moveRight = () => {
    if (
      currentSelectedTag.Tag!== '' &&
      currentSelectedTag.Aggregation!== '' &&
      aggregationOption.length > 0 &&
      selectedTagDetails
    ) {

      if(openTagDialog[1] === "Guzzlers"){
        // Create entries - filter out duplicates
          const ifDuplicate =  selectedTag.filter((val) => val.Aggregation === currentSelectedTag.Aggregation && val.Tag === selectedTagDetails.key && val.Device === currentSelectedTag.Device);    

            if(ifDuplicate.length === 0){
              setSelectedTag([...selectedTag,{...currentSelectedTag}]);
            }
        }else{
          // For other tags, only one selection allowed, so replace existing entry
          setSelectedTag([{...currentSelectedTag}]);
        }

      // Clear selections
      setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
      setSelectedTagDetails(null);
      setAggregationOption([]);
      setDisabledAggOptions([]);
    } 
  };

  function handlePowerSupplyEB(selected) {
    powerSupply.EB = selected;
    setpowerSupply(powerSupply);
  }
  function handlePowerSupplyDG(selected) {
    powerSupply.DG = selected;
    setpowerSupply(powerSupply);
  }
  function handlePowerSupplyRE(selected) {
    powerSupply.RE = selected;
    setpowerSupply(powerSupply);
  }

  function handleShiftName(selected, event) {
    shiftDetails[event.currentTarget.id][0] = selected;
    setShiftDetails(shiftDetails);
  }

  function handleShiftTime(selected, id, e_) {
    if (id.includes("_start")) {
      id = id.split("_")[0];
      shiftDetails[id][1][0] = selected;
    } else if (id.includes("_end")) {
      id = id.split("_")[0];
      shiftDetails[id][1][1] = selected;
    }
    setShiftDetails(shiftDetails);
  }

  function handleShiftDelete(event) {
    if (shiftDetails.length > 1) {
      const temp = shiftDetails.filter(
        (_value, index) => index !== parseInt(event.currentTarget.id, 10),
      );
      setShiftDetails(temp);
    } else {
      setShiftDetails([["", [dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]]]);
    }
  }

  // useEffect(()=>{
  // },[shiftDetails])

  function handleShiftAdd() {
    if (shiftDetails.length < 4) {
      setShiftDetails([
        ...shiftDetails,
        ["", [dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]],
      ]);
    } else {
      setMaxlimitmsg([1, "Max 4 Shifts can be added"]);
    }
  }

  function handleTODZone(selected, event) {
    TOD[event.currentTarget.id][0] = selected;
    setTOD(TOD);
  }

  function handleTODUnitRate(selected, event) {
    TOD[event.currentTarget.id][2] = selected;
    setTOD(TOD);
  }

  function handleTODTime(selected, id, e_) {
    let id1 = "";
    let index = "";
    let e = 0;
    if (id.includes("_start")) {
      id = id.split("_")[0];
      const dotindex = id.indexOf(".");
      index = id.slice(0, dotindex);
      id1 = id.slice(dotindex + 1);
    } else if (id.includes("_end")) {
      id = id.split("_")[0];
      const dotindex = id.indexOf(".");
      index = id.slice(0, dotindex);
      id1 = id.slice(dotindex + 1);
      e = 1;
    }
    // const dotindex = id.indexOf(".");
    // const index = id.slice(0, dotindex);
    TOD[index][1][id1][e] = selected;
    setTOD(TOD);
  }

  function handleTODAdd() {
    if (TOD.length < 8) {
      setTOD([
        ...TOD,
        [
          "",
          [[dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]],
          "",
        ],
      ]);
    } else {
      setMaxlimitmsg([1, "Max 8 TOD can be added"]);
    }
  }

  function handleTODTimeAdd(event) {
    if (TOD[event.currentTarget.id][1].length < 8) {
      setTOD([...TOD, ["", [""], ""]]);
      const temp = [
        ...TOD[event.currentTarget.id][1],
        [dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")],
      ];
      TOD[event.currentTarget.id][1] = [...temp];
      setTOD([...TOD]);
    } else {
      setMaxlimitmsg([1, "Max 8 TOD time can be added"]);
    }
  }

  function handleTODDelete(event) {
    if (TOD.length > 1) {
      const temp = TOD.filter(
        (_value, index) => index !== parseInt(event.currentTarget.id, 10),
      );
      setTOD(temp);
    } else {
      setTOD([["", [[dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")]], ""]]);
    }
  }

  function handleTODTimeDelete(event) {
    const dotindex = event.currentTarget.id.indexOf(".");
    const index = event.currentTarget.id.slice(0, dotindex);
    const id = parseInt(event.currentTarget.id.slice(dotindex + 1), 10);
    if (TOD[index][1].length > 1) {
      const temp = TOD[index][1].filter((_value, index) => index !== id);
      TOD[index][1] = [...temp];
      setTOD([...TOD]);
    } else {
      TOD[index][1] = [dayjs("2022-04-17T00:00:00"), dayjs("2022-04-17T00:00:00")];
      setTOD([...TOD]);
    }
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

   const cloneShiftDetails = (details) =>
    details.map(([shiftName, range]) => {
      const [start, end] = range;
      return [shiftName, [dayjs(start), dayjs(end)]];
    });

  const cloneTOD = (tod) =>
    tod.map(([zoneName, ranges, unitRate]) => [
      zoneName,
      ranges.map(([start, end]) => [dayjs(start), dayjs(end)]),
      unitRate,
    ]);

  function handleConfirmCancel() {
    setSaveStatus(0);
    const powerSupplyData = {
      EB: handleDeviceIDtoName([OGData[0].EB]),
      DG: handleDeviceIDtoName([OGData[0].DG]),
      RE: handleDeviceIDtoName([OGData[0].RE]),
    };
    setpowerSupply({
      EB: powerSupplyData.EB.length !== 0 ? powerSupplyData.EB[0] : "",
      DG: powerSupplyData.DG.length !== 0 ? powerSupplyData.DG[0] : "",
      RE: powerSupplyData.RE.length !== 0 ? powerSupplyData.RE[0] : "",
    });
    setSelectedDevicesList(handleDeviceIDtoName(OGData[0].GuzzlerDeviceID));
    setGuzzlersSelectedTags(OGData[0].GuzzlersEnergyTag);
    // setpowerSupply({'EB':OGData[0].EB,'DG':OGData[0].DG,'RE':OGData[0].RE});
    // setSelectedDevicesList(OGData[0].GuzzlerDeviceID);
    setMDThershold(OGData[0].MDThreshold);
    setMDTag(OGData[0].MDTag);
    setShiftDetails(cloneShiftDetails(OGData[0].ShiftDetails));
    // setShiftDetails(OGData[0].ShiftDetails);
    const todCopy = cloneTOD(OGData[0].TOD);
    setTOD(todCopy);
    // setTOD(OGData[0].TOD);
    setShowWidget(OGData[0].ShowWidget);
    setOpenCancelDialog(false);
  }

  function handleCloseTagDialog() {
    setSelectedTag([]);
    setSelectedDevice([]);
    setOpenTagDialog([false, ""]);
    setRightList([...table_rows]);
    setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
    setSelectedTagDetails(null);
    setAggregationOption([]);
    setSelectedRightItems([]);
    setDisabledAggOptions([]);
    //handleClose(event, "closeButton");
  }

  function handleTagConfirmDialog() {
    if(openTagDialog[1] === "EB"){
      powerSupply.EB = selectedDevice.length > 0 ? selectedDevice[0] : "";
      powerTagSupply.EBTag = selectedTag.length > 0 ? selectedTag[0] : "";
      setpowerSupply(powerSupply);
      setpowerTagSupply(powerTagSupply);
    }
    else if(openTagDialog[1] === "DG"){
      powerSupply.DG = selectedDevice.length > 0 ? selectedDevice[0] : "";
      powerTagSupply.DGTag = selectedTag.length > 0 ? selectedTag[0] : "";
      setpowerSupply(powerSupply);
      setpowerTagSupply(powerTagSupply);
    }
    else if(openTagDialog[1] === "RE"){
      powerSupply.RE = selectedDevice.length > 0 ? selectedDevice[0] : "";
      powerTagSupply.RETag = selectedTag.length > 0 ? selectedTag[0] : "";
      setpowerSupply(powerSupply);
      setpowerTagSupply(powerTagSupply);
    }
    else if(openTagDialog[1] === "Guzzlers"){
      setGuzzlersSelectedTags([...selectedTag]);
      // setGuzzlersSelectedTags([...selectedTag]);
      // setSelectedDevicesList([...selectedDevice]);
    }
    else if(openTagDialog[1] === "MDTag" ){
      setMDTag(selectedTag.length > 0 ? {Device:selectedTag[0].Device, Tag:selectedTag[0].Tag, Aggregation:selectedTag[0].Aggregation} : {Device:'',Tag:'',Aggregation:''});
    }
    setOpenTagDialog([false, ""]);
    setSelectedTag([]);
    setSelectedDevice([]);
    setCurrentSelectedTag({Device:'', Tag:'', Aggregation:''});
    setSelectedRightItems([]);
    //saveTaglist();
  }


  useEffect(() => {
      if (currentSelectedTag.Tag !== '' && selectedTagDetails !== null) {
  
        // Check if selectedTagDetails has storage property
        
        if (selectedTagDetails.storage && Array.isArray(selectedTagDetails.storage)) 
        {

          let data =[];

          selectedTagDetails.storage.forEach((obj) => {
            const value = Object.values(obj)[0];
            value.map((val) => {
              data.push(val);
            });
          });

          const aggreationFunctions = [...new Set(data)];
  
          if (aggreationFunctions !== null && Array.isArray(aggreationFunctions)) {
            // value should contain the available aggregation options
            // Disable all options that are NOT in the value array
            const allOptions = [
              "SUM",
              "DIFF",
              "AVG",
              "MIN",
              "MAX",
              "SVAL",
              "EVAL",
            ];
            const disabledOptions = allOptions.filter(
              (option) => !aggreationFunctions.includes(option),
            );

            setDisabledAggOptions(disabledOptions);
          } else {
            // If no storage found, disable all options
            setDisabledAggOptions([
              "SUM",
              "DIFF",
              "AVG",
              "MIN",
              "MAX",
              "SVAL",
              "EVAL",
            ]);
          }
        } else {
          // If no storage property, disable all options
          setDisabledAggOptions([
            "SUM",
            "DIFF",
            "AVG",
            "MIN",
            "MAX",
            "SVAL",
            "EVAL",
          ]);
        }
      } else {
        // Clear disabled options when no tag is selected ///????when  no tag selected all should be disabled right?
        // setDisabledAggOptions([]);
        setDisabledAggOptions(["SUM", "DIFF", "AVG", "MIN", "MAX", "SVAL", "EVAL"]);
      }
    }, [currentSelectedTag, selectedTagDetails]); 

  
  const processTreeData = (nodes, mode, pkey) => {
    return nodes.map((node) => {
      const processedNode = {
        ...node,
        title: renderTitle(node.title || node.key, node.type, node.key, node, mode, pkey),
        children: node.children ? processTreeData(node.children, mode, node.key) : undefined,
      };
      return processedNode;
    });
  };


  // Helper to create node titles with right-aligned icons
    const renderTitle = (title, type, key, node, mode, pkey) => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
          }}
        >
          {/* Left side: title with icon */}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {type === "tag" ? (
              <CustomCheckbox
                checked={currentSelectedTag.Tag===key}
                onChange={(checked) => {
                  if(mode === "single"){
                    if (checked) {
                      // setSelectedTag([key]);
                      // setSelectedDevice([pkey]);
                      setCurrentSelectedTag({Tag: key, Device: pkey, Aggregation: ''});
                      setSelectedTagDetails({
                          key: key,
                          title: title,
                          fullPath: node.fullPath || title,
                          parentPath: node.parentPath || "",
                          storage: node.storage,
                        });
                      // setCurrStorage(node.storage);
                    } else {
                      // setSelectedTag([]);
                      // setSelectedDevice([]);
                      setCurrentSelectedTag({Tag: '', Device: '', Aggregation: ''});
                      setSelectedTagDetails(null);
                      // setCurrStorage(null);
                    }
                  }
                  else{
                    if (checked) {
                      // setSelectedTag([...selectedTag, key]);
                      // setSelectedDevice([...selectedDevice, pkey]);
                      setCurrentSelectedTag({Tag: key, Device: pkey, Aggregation: ''});
                      setSelectedTagDetails({
                          key: key,
                          title: title,
                          fullPath: node.fullPath || title,
                          parentPath: node.parentPath || "",
                          storage: node.storage,
                        });
                      // setCurrStorage(node.storage);
                    } else {
                      // setSelectedTag(selectedTag.filter((tag) => tag !== key));
                      // setSelectedDevice(selectedDevice.filter((device) => device !== pkey));
                      setCurrentSelectedTag({Tag: '', Device: '', Aggregation: ''});
                                        setSelectedTagDetails(null);
                      // setCurrStorage(null);
                    }
                  }
                }}
              />
            ) : (
              <></>
            )}
            <span
              style={{ color: theme === "dark" ? "#FFFFFF" : "#5B5B5B" }}
            >
              {title}
            </span>
          </div>
        </div>
      );
    };

  //   const onSelect = (selectedKeys, info) => {
  // };

  function handleIDtoName(tags) {
  let data =[]
  tags.map((dval) => {
    tagConfiguration.map((val) => {
        if (val.key === dval.Device) {
          // tagID.map((tval) => {
            let tagmatch = val.children.filter((tag) => tag.key === dval.Tag); 
            // if(val.tags){
            // }
            if(tagmatch.length > 0){  
              data.push(val.title +"."+ tagmatch[0].title);
            }
          // })
        }
      });
    });
    return data;
  }

    return (

        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box" }}>
            <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:"8px"}} >
                    <Box sx={{flexGrow:1}}></Box>
                    <CustomDialogBox dialogTitle={"Required fields not filled"} dialogText={"Required fields to must be filled"} openDialog={required===1} handleCloseDialog={()=>setRequired(0)} handleConfirmDialog={()=>setRequired(0)} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    {saveStatus!==0?
                        <>
                            {/* <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography> */}
                            {saveStatus!==0?<CustomToast openToast={saveStatus!==0} /*type={ saveStatus===1?"Success":"Error"}*/ autoHideDuration={10000} toastText={saveStatus===1?"Saved Successfully!":"Save Failed"} onClose={handleToastClose}/>:<></>}
                        </>
                        :
                        <></>
                    }
                    <CustomCancelButton onClick={handleCloseAddForm} disabled={disableButtons !== 0 ? true : false} buttonText={'Cancel'}></CustomCancelButton>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                    <CustomButton /*id={assetInfo.id}*/ onClick={handleSaveAddForm} disabled={disableButtons !== 0 ? true : false} buttonText={'Save'} width={'12px'} />
                    <CustomDialogBox dialogTitle={"Addition max limit"} dialogText={maxlimitmsg[1]} openDialog={maxlimitmsg[0]===1} handleCloseDialog={()=>setMaxlimitmsg([0,""])} handleConfirmDialog={()=>setMaxlimitmsg([0,""])} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                    <CustomDialogBox dialogTitle={"Are you sure you want cancel"} dialogText={"All the changes made will be discarded."} openDialog={openCancelDialog} handleCloseDialog={()=>setOpenCancelDialog(false)} handleConfirmDialog={handleConfirmCancel} confirmText={"OK"} cancelText={"Cancel"} type={"Warning"}/>
                </Box>
                <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"auto"}}>
                    {loading===1?
                        <Box sx={{gap:'8px',boxSizing:"border-box",height:'calc(100%)',width:'100%',alignContent:"center"}} >
                            <img src={LK_Loading} alt="loading..." style={{height:"15%" ,width:"auto",alignSelf:"center"}} />
                        </Box>
                        :
                        <>
                        {/* <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Power supply<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                            <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                <>
                                    <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px"}}>EB</Typography>
                                        {/* <CustomDropDown options={devicelist[1]} id={'EB'} onChange={handlePowerSupplyEB} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.EB!==""?powerSupply.EB:devicelist[1][0]}></CustomDropDown>
                                        <CustomDropDown options={devicelist[1]} id={'EB'} onChange={handlePowerSupplyEB} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.EB!==""?powerSupply.EB:devicelist[1][0]}></CustomDropDown> *}
                                        <CustomButton onClick={()=>{setOpenTagDialog([true, "EB"]); setSelectedDevice([powerSupply.EB]);setSelectedTag([powerTagSupply.EBTag])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                        {(powerSupply.EB!=="")?<CustomSelectedOptions id={"EB"} selectedOptions={powerSupply.EB!==""?handleIDtoName([powerSupply.EB],[powerTagSupply.EBTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>}
                                        {/* <AssetTagsRetrievalModified 
                                    assetdata={assetdata} 
                                    setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                    setSelectedTag={setSelectedTag} 
                                    setSelectedAsset={setSelectedAsset} 
                                /> *}
                                    </Box> 
                                    <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px"}}>DG</Typography>
                                        {/* <CustomDropDown options={devicelist[1]} id={'DG'} onChange={handlePowerSupplyDG} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.DG!==""?powerSupply.DG:devicelist[1][0]}></CustomDropDown>
                                        <CustomDropDown options={devicelist[1]} id={'DG'} onChange={handlePowerSupplyDG} /*disabled={props.gatewayData.id!=="" ?true:false}/ defaultValue={powerSupply.DG!==""?powerSupply.DG:devicelist[1][0]}></CustomDropDown> *}
                                        <CustomButton onClick={()=>{setOpenTagDialog([true, "DG"]); setSelectedDevice([powerSupply.DG]);setSelectedTag([powerTagSupply.DGTag])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                         {(powerSupply.DG!=="")?<CustomSelectedOptions id={"DG"} selectedOptions={powerSupply.DG!==""?handleIDtoName([powerSupply.DG],[powerTagSupply.DGTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>}
                                    </Box>
                                    <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',width:"100%"}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"44px"}}>RE</Typography>
                                        {/* <CustomDropDown options={devicelist[1]} id={'RE'} onChange={handlePowerSupplyRE} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.RE!==""?powerSupply.RE:devicelist[1][0]}></CustomDropDown>
                                        <CustomDropDown options={devicelist[1]} id={'RE'} onChange={handlePowerSupplyRE} /*disabled={props.gatewayData.id!=="" ?true:false}* defaultValue={powerSupply.RE!==""?powerSupply.RE:devicelist[1][0]}></CustomDropDown> *}
                                        <CustomButton onClick={()=>{setOpenTagDialog([true, "RE"]); setSelectedDevice([powerSupply.RE]);setSelectedTag([powerTagSupply.RETag])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                        {(powerSupply.RE!=="")?<CustomSelectedOptions id={"RE"} selectedOptions={powerSupply.RE!==""?handleIDtoName([powerSupply.RE],[powerTagSupply.RETag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>}
                                    </Box>
                                </>
                            </Box>
                        </Box> */}
                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px"}}>Guzzlers</Typography>
                            <Box sx={{flexDirection:'column',width:'calc(100% - 248px)',display:'flex',gap:'16px'/*maxHeight:'500px',overFlow:'auto'*/}}>
                                {/* <CustomMultiselectWithCheckbox options={devicelist[1]} selecteddata={selectedDevicesList} onChange={handleSelectedOption} maxLimit={11}/> */}
                                    <Box sx={{flexDirection:'row',width:'100%',display:'flex',gap:'8px'}}>
                                      <CustomCheckbox checked={showWidget.Guzzlers} onChange={(selected)=>{setShowWidget({...showWidget, Guzzlers: selected})}}></CustomCheckbox>
                                       <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C'}}>Show Guzzlers</Typography>
                                    </Box>
                                    <Box sx= {{ flexDirection:'column',width:'100%',maxHeight:'250px',overFlow:'auto',display:'flex'}}> 
                                      <CustomButton onClick={()=>{setOpenTagDialog([true, "Guzzlers"]); setSelectedDevice(selectedDevicesList);setSelectedTag(guzzlersSelectedTags)}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                                      {/* {(powerSupply.DG!=="")?<CustomSelectedOptions id={"Guzzlers"} selectedOptions={powerSupply.DG!==""?handleIDtoName([powerSupply.DG],[powerTagSupply.DGTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>} */}
                                      <Box sx={{display:'flex' , flexDirection:'row' ,padding:'12px 0px',alignSelf:'end',alignItems:'end',maxHeight:'200px',width:'100%', overflowY:'auto'}}>
                                          {/* {(selectedDevicesList.length>0)?<CustomSelectedOptions selectedOptions={selectedDevicesList} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>} */}
                                          {(guzzlersSelectedTags.length>0)?<CustomSelectedOptions id={"Guzzlers"} selectedOptions={guzzlersSelectedTags.length>0?handleIDtoName(guzzlersSelectedTags):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions>:<></>}
                                      </Box>
                                 </Box>
                            </Box>
                        </Box>
                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"16px"}}>
                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Threshold for Max Demand (kW)<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                            <CustomNumberField min={0} id={'Duration'} onChange={handleMDThershold} defaultValue={MDThershold} maxLength={500} width={'224px'}  permittedCharacters={'^[a-zA-Z][a-zA-Z0-9_]*$'}/> 
                            <CustomButton onClick={()=>{setOpenTagDialog([true, "MDTag"]); setSelectedTag(MDTag.Tag!=='' && MDTag.Aggregation!==''?[{Device:MDTag.Device,Tag:MDTag.Tag,Aggregation:MDTag.Aggregation}]:[])}} buttonText={"Select Tag"} width={"130px"}></CustomButton>
                            {(MDTag.Tag!=="")?<Box sx={{width:"231px", }}><CustomSelectedOptions id={"MDTag"} selectedOptions={MDTag.Tag!==""?handleIDtoName([MDTag]):[]} onClick={handleRemoveOption} chipWidth={221}></CustomSelectedOptions></Box>:<></>}
                            {/* <CustomTextField id={'negative-feedback'} onChange={handleMDThershold} defaultValue={MDThershold} permittedCharacters={'^-?\\d*(\\.?\\d*)?$'} errorText={"Only numeric characters are allowed"} maxLength={16} width={224}/>  */}
                        </Box>
                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"16px"}}>
                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>Shiftwise</Typography>
                            <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                <Box sx={{flexDirection:'row',width:'100%',display:'flex',gap:'8px'}}>
                                      <CustomCheckbox checked={showWidget.Shiftwise} onChange={(selected)=>{setShowWidget({...showWidget, Shiftwise: selected})}}></CustomCheckbox>
                                       <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C'}}>Show Shiftwise Data</Typography>
                                    </Box>
                                    <>
                                    {/* <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Tag <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                        <CustomTextField  onChange={handleTODZone} disabled={true} defaultValue={'Energy'} maxLength={16} width={224}/> 
                                    </Box> */}
                                    <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Shift Name {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"464px"}}>Shift Time {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                        <Button  onClick={handleShiftAdd} sx={{width:'28px','& .MuiButtonBase-root.MuiButton-root':{width:'28px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'28px',fontWeight: 400,alignSelf:"center",marginTop:'-8px',minWidth:'28px'}}><LK_Add color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
                                    </Box> 
                                    {shiftDetails.map((_value,index)=>(
                                    <>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomTextField id={index} onChange={handleShiftName} defaultValue={shiftDetails[index][0]} maxLength={16} width={224}/> 
                                            {/* <CustomTextField id={index} onChange={handleShiftTime} defaultValue={shiftDetails[index][1]} maxLength={16} width={224}/>  */}
                                            <CustomTimePicker id={index+"_start"} ampm={false} onChange={handleShiftTime} defaultValue={shiftDetails[index][1][0]} width={'224px'} timeSteps={{hours: 1, minutes: 5, seconds: 60}}/>
                                            <CustomTimePicker id={index+"_end"} ampm={false} onChange={handleShiftTime} defaultValue={shiftDetails[index][1][1]} width={'224px'} timeSteps={{hours: 1, minutes: 5, seconds: 60}}/>
                                            <Button id={index} onClick={handleShiftDelete}  sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'32px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'32px',fontWeight: 400,alignSelf:"center",marginTop:'-8px',minWidth:'28px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                        </Box> 
                                    </>
                                ))}
                                </>
                            </Box>
                        </Box>
                        <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"16px"}}>
                            <Typography  style={{ fontSize: '18px', fontWeight: 400, color: "var(--GreyVariation_2)",width:"224px" }}>TOD</Typography>
                            {/* <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}> */}
                                 <Box sx={{flexDirection:'column',display:'flex',width:"calc(100% - 224px)",}}>
                                    <Box sx={{flexDirection:'row',width:'100%',display:'flex',gap:'8px'}}>
                                      <CustomCheckbox checked={showWidget.TOD} onChange={(selected)=>{setShowWidget({...showWidget, TOD: selected})}}></CustomCheckbox>
                                      <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C'}}>Show TOD Data</Typography>
                                    </Box>
                                    <>
                                    {/* <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Tag <span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span></Typography>
                                        <CustomTextField  onChange={handleTODZone} disabled={true} defaultValue={'Energy'} maxLength={16} width={224}/> 
                                    </Box> */}
                                    <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>TOD Name{/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"512px"}}>TOD Time{/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Unit Rate {/*<span style={{ color: "var(--RedBaseColor)", marginLeft: "5px" }}>*</span>*/}</Typography>
                                        <Button  onClick={handleTODAdd} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'28px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'28px',fontWeight: 400,alignSelf:"center",marginTop:'-8px', minWidth:'28px'}}><LK_Add color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
                                    </Box> 
                                    {TOD.map((_value,index)=>(
                                    <>
                                        <Box sx={{display:'flex' , flexDirection:'row' ,padding:'8px 0px',alignSelf:'left',justifyContent:'start',gap:'16px',}}>
                                            <CustomTextField id={index} onChange={handleTODZone} defaultValue={TOD[index][0]} maxLength={16} width={224}/> 
                                            {/* <CustomTextField id={index} selected={handleTODTime} defaultValue={TOD[index][1]} maxLength={16} width={224}/>  */}
                                            <Box sx={{flexDirection:'column',display:'flex',width:"512px",gap:"8px"}}>
                                                {TOD[index][1].map((_value,id)=>(
                                                    <>    
                                                        <Box sx={{flexDirection:'row',display:'flex',gap:"16px"}}>
                                                        <CustomTimePicker id={index.toString()+"."+id+"_start"} ampm={false} onChange={handleTODTime} defaultValue={TOD[index][1][id][0]} timeSteps={{hours: 1, minutes: 5, seconds: 60}} width={'224px'}/>
                                                        <CustomTimePicker id={index.toString()+"."+id+"_end"} ampm={false} onChange={handleTODTime} defaultValue={TOD[index][1][id][1]} timeSteps={{hours: 1, minutes: 5, seconds: 60}} width={'224px'}/>
                                                        {/* <CustomTextField id={index.toString()+"."+id} onChange={handleTODTime} defaultValue={TOD[index][1][id]} maxLength={16} width={264}/>  */}
                                                        {id===0?
                                                            <Button  id={index} onClick={handleTODTimeAdd} sx={{width:'28px','& .MuiButtonBase-root.MuiButton-root':{width:'28px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'28px',fontWeight: 400,alignSelf:"center",marginTop:'-8px', minWidth:'28px'}}><LK_Add color='var(--LK_BrandBlue)' width={"20px"} height={"20px"}/></Button>
                                                            :
                                                            <Button id={index.toString()+"."+id} onClick={handleTODTimeDelete}  sx={{width:'28px','& .MuiButtonBase-root.MuiButton-root':{width:'28px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'28px',fontWeight: 400,alignSelf:"start",marginTop:'0px', minWidth:'28px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                                        }
                                                        </Box>
                                                    </>
                                                ))}
                                            </Box>
                                            <CustomTextField id={index} onChange={handleTODUnitRate} defaultValue={TOD[index][2]} maxLength={16} width={224}/> 
                                            <Button id={index} onClick={handleTODDelete}  sx={{width:'28px','& .MuiButtonBase-root.MuiButton-root':{width:'28px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'28px',fontWeight: 400,alignSelf:"start",marginTop:'0px', minWidth:'28px'}}><LK_Delete color='var(--LK_BrandBlue)'  width={"28px"} height={"28px"}/></Button>
                                        </Box> 
                                    </>
                                ))}
                                </>
                                </Box>
                            {/* </Box> */}
                        </Box>
                        </> 
                    }
                </Box>
                {
                  <Dialog
                      open={openTagDialog[0]}
                      // onClose={handleCloseDialog}
                      sx={{ "& .MuiDialog-paper": { backgroundColor:(theme == 'light')?"#FFFFFF":"#19191B",alignContent:"center",borderRadius:0,gap:'2px', width: '900px',maxWidth:'1200px'} }}
                  >
                      <DialogTitle  sx={{marginTop:'16px',marginBottom:'8px', fontFamily:'Roboto',alignContent:"center",justifyContent:"left",textAlign:'left','&.MuiDialogTitle-root':{padding:'0px 16px'}}}>
                          {"Select Device and Tag"}
                      </DialogTitle>
                      <DialogContent sx={{alignContent:"center",marginBottom:'4px','&.MuiDialogContent-root':{padding:'0px 16px'}}} >
                          <Box
                            sx={{
                              width: "100%",
                              minHeight: "400px",
                              maxHeight: "650px",
                              height: "650px",
                              backgroundColor:
                                theme === "dark" ? "#1e1e1e" : "#FFFFFF",
                              display: "flex",
                              flexDirection: "row",
                              gap: "12px",
                              boxSizing: "border-box",
                            }}
                          >
                            <Box
                              sx={{
                                width: "40%",
                                height: "100%",
                                minHeight: "400px",
                                backgroundColor:
                                  theme === "dark" ? "#000000" : "#EFEFEF",
                                padding: "8px",
                                boxSizing: "border-box",
                              }}
                            > 
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  height: "26px",
                                  marginBottom: "10px",
                                  borderBottom:
                                    theme === "dark"
                                      ? "1px solid #3c3c3c"
                                      : "1px solid #c1c1c1",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                    fontSize: "16px",
                                    fontWeight: 700,
                                  }}
                                >
                                  Tags
                                </Typography>
                                <Box sx={{ flexGrow: 1 }}> </Box>
                              </Box>
                              <Box
                                sx={{
                                  flex: 1, // ← takes all remaining height after the title
                                  minHeight: 0, // ← CRITICAL: allows flex child to shrink below content size
                                  overflowY: "auto", // ← scroll happens HERE, not on Tree
                                  // overflowX: "hidden",
                                  height: "calc(100% - 36px)",
                                  backgroundColor:theme === "dark" ? "#000000" : "#EFEFEF",
                                  boxSizing: "border-box",
                                  //  '& .ant-tree-switcher-noop': { width: '0px' }
                                }}
                              >
                                <Tree
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#000000" : "#EFEFEF",
                                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                  }}
                                  switcherIcon={(nodeProps) => {
                                    if (nodeProps.isLeaf) {
                                      return null; // No icon for leaf nodes 
                                    }
                                    return nodeProps.expanded ? <LK_ArrowDown color='#008cd7' width={"12px"} height={"12px"}/>:<LK_ArrowRight color='#008cd7' width={"12px"} height={"12px"}/>;
                                  }}
                                  // selectable={false}
                                  // onSelect={onSelect}
                                  treeData={(processTreeData(tagConfiguration,openTagDialog[1]==="Guzzlers"?"multiple":"single"))}
                                />
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                width: "20%",
                                height: "calc(100% - 32px)",
                                padding: "8px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "16px",
                                boxSizing: "border-box",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <CustomButton
                                  onClick={moveRight}
                                  buttonText={">"}
                                  disabled={
                                    currentSelectedTag.Aggregation === ''
                                  }
                                />
                                <CustomButton
                                  onClick={moveLeft}
                                  buttonText={"<"}
                                  disabled={selectedRightItems.length === 0}
                                />
                              </Box>
                              <Box
                                sx={{
                                  backgroundColor:
                                    theme === "dark" ? "#000000" : "#EFEFEF",
                                  padding: "16px",
                                  visibility: "visible",
                                  width: "100%",
                                  boxSizing: "border-box",
                                }}
                              >
                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("SUM"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "SUM"}
                                  onChange={(val) => handleAggregationOption("SUM", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"SUMMATION"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("DIFF"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "DIFF"}
                                  onChange={(val) => handleAggregationOption("DIFF", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"DIFFERENCE"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("AVG"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "AVG"}
                                  onChange={(val) => handleAggregationOption("AVG", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"AVERAGE"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("MIN"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "MIN"}
                                  onChange={(val) => handleAggregationOption("MIN", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"MINIMUM"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("MAX"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "MAX"}
                                  onChange={(val) => handleAggregationOption("MAX", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"MAXIMUM"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("SVAL"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "SVAL"}
                                  onChange={(val) => handleAggregationOption("SVAL", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"START VALUE"}
                                />
                                <br />

                                <CustomCheckbox
                                  disabled={
                                    (currentSelectedTag.Tag === '' ||
                                      disabledAggOptions.includes("EVAL"))
                                  }
                                  checked={currentSelectedTag.Aggregation === "EVAL"}
                                  onChange={(val) => handleAggregationOption("EVAL", val)}
                                />
                                <span>&nbsp;</span>
                                <span>&nbsp;</span>
                                <CustomLabel
                                  fontWeight={300}
                                  fontSize={14}
                                  color={"var(--PrimaryText)"}
                                  labelText={"END VALUE"}
                                />
                                <br />
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                width: "40%",
                                height: "100%",
                                minHeight: "400px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "16px",
                                boxSizing: "border-box",
                              }}
                            >
                              <Box
                                sx={{
                                  height: "100%",
                                  width: "100%",
                                  backgroundColor:
                                    theme === "dark" ? "#000000" : "#EFEFEF",
                                  padding: "8px",
                                  boxSizing: "border-box",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginBottom: "10px",
                                    borderBottom:
                                      theme === "dark"
                                        ? "1px solid #3c3c3c"
                                        : "1px solid #c1c1c1",
                                        height: "26px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color:
                                        theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                                      fontSize: "16px",
                                      fontWeight: 700,
                                    }}
                                  >
                                    Selected {/* ({rightList.length}) */}
                                  </Typography>
                                  <Box sx={{ flexGrow: 1 }}> </Box>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                    marginTop: "8px",
                                    overflow: "auto",
                                    height: "calc(100% - 26px)",
                                  }}
                                >
                                  {selectedTag.length === 0 ? (
                                    <Typography
                                      sx={{
                                        color:
                                          theme === "dark" ? "#888888" : "#999999",
                                        fontSize: "14px",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      No tags added yet
                                    </Typography>
                                  ) : (
                                    selectedTag.map((item, index) => (
                                      <Box
                                        key={index}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          padding: "4px",
                                        }}
                                      >
                                        <CustomCheckbox
                                          checked={selectedRightItems.includes(item)}
                                          onChange={(checked) => {
                                            if (checked) {
                                              // Add to selected items
                                              setSelectedRightItems([
                                                ...selectedRightItems,
                                                item,
                                              ]);
                                            } else {
                                              // Remove from selected items
                                              setSelectedRightItems(
                                                selectedRightItems.filter(
                                                  (i) => i !== item,
                                                ),
                                              );
                                            }
                                          }}
                                        />
                                        <CustomLabel
                                          fontWeight={300}
                                          fontSize={14}
                                          color={"var(--PrimaryText)"}
                                          labelText={(handleIDtoName([item])) + "." + item.Aggregation}
                                        />
                                      </Box>
                                    ))
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                      </DialogContent>
                      <DialogActions sx={{justifyContent:'left',padding:"16px"}}> 

                        {<CustomButton onClick={handleTagConfirmDialog}  id={openTagDialog[1]} buttonText={"Save"} /*disabled={currentSelectedTag.Tag!==''}*/  width={100}></CustomButton>} 
                        {<CustomCancelButton onClick={handleCloseTagDialog} /*disabled={currentSelectedTag.Tag!==''}*/ buttonText={"Cancel"} width={100}></CustomCancelButton>} 
                      </DialogActions>
                  </Dialog>
                }
            </Box>
        </Box>
            )

}
